module.exports = __webpack_public_path__ + "static/graph-df0381bd70b77b1fd990ac9e7998d2de.svg";